module.exports = __webpack_public_path__ + "static/media/band1.fb37f142.jpg";